import axios from 'axios';
import { get } from 'lodash-es';
import { from } from 'rxjs';

/**
 * @typedef {object} BulkLoadResponseContract
 * @property {object[]} salesOrders
 * @property {object[]} fulfillmentPlans
 * @property {object[]} fulfillments
 * @property {object[]} fulfillmentPlanSets
 * @property {object[]} returns
 * @property {object[]} products
 */

/**
 * @param {string[]} fulfillmentPlanIds
 * @returns {Promise<BulkLoadResponseContract>}
 */
export const bulkLoadFulfillmentPlanIds = (fulfillmentPlanIds = []) =>
  axios.post('/bulkload/ByFulfillmentPlanIds', fulfillmentPlanIds).then(({ data }) => data);

export const getByFulfillmentPlanIds = (fulfillmentPlanIds = []) => {
  const post = bulkLoadFulfillmentPlanIds(fulfillmentPlanIds);

  const post$ = from(post);
  return post$;
};

/**
 * @param {string[]} salesOrderIds
 * @returns {Promise<BulkLoadResponseContract>}
 */
export const bulkLoadSalesOrderIds = (salesOrderIds = []) =>
  axios.post('/bulkload/BySalesOrderIds', salesOrderIds).then(({ data }) => data);

export const getBySalesOrderIds = (salesOrderIds = []) => {
  const post = bulkLoadSalesOrderIds(salesOrderIds);

  const post$ = from(post);
  return post$;
};

export const getByFulfillmentPlanSetIds = (fulfillmentPlanSetIds = []) => {
  const post = axios.post('/bulkload/byFulfillmentPlanSetIds', fulfillmentPlanSetIds).then((response) => {
    return get(response, 'data');
  });

  const post$ = from(post);
  return post$;
};

/**
 * @param {string[]} labelFulfillmentIds
 * @returns {Promise<BulkLoadResponseContract>}
 */
export const bulkLoadLabelFulfillmentIds = (labelFulfillmentIds = []) =>
  axios.post('/bulkload/ByLabelFulfillmentIds', labelFulfillmentIds).then(({ data }) => data);

export const getByLabelFulfillmentIds = (labelFulfillmentIds = []) => {
  const post = bulkLoadLabelFulfillmentIds(labelFulfillmentIds);

  const post$ = from(post);
  return post$;
};
